export default __webpack_public_path__ + "static/blockchain_banner-31804d44859fd2d783cdc785be33ee77.webp";